import React, { useState } from 'react';

import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, UiButton } from '@shared/ui';

import cls from './ChangeStartDateModal.module.css';
import { DateInput } from '../../../../components/DateInput/DateInput';
import { useChangeDateStages } from '../../../../TemporaryConmonents/Gant/hooks/useChangeDateStages';

export const ChangeStartDateModal = ({ isOpen, onShowChange, isChangeStatus }) => {
    const { t } = useTranslation();
    const { onChangeStartDate } = useChangeDateStages(isChangeStatus);
    const onHideModal = () => {
        onShowChange();
    };

    const [date, setDate] = useState(null);
    const changeDate = (date) => {
        setDate(moment(date).format());
    };

    const changeStartDate = () => {
        onChangeStartDate(date);
        onShowChange();
    };

    return (
        <CustomModal contentClasses={cls.SettingsModal} isOpen={isOpen} onHideModal={onHideModal}>
            <CustomModal.Header>{t('Gant.ChangeStartDateModal.Header')}</CustomModal.Header>
            <CustomModal.Body>
                <div className={cls.body}>
                    <div className={cls.dateInput}>
                        <DateInput
                            newCallback={changeDate}
                            placeholder={t('Gant.ChangeStartDateModal.DateInput.placeholder.text')}
                            inventoryGuid="guid"
                            parameterName="startDate"
                            options={{
                                autoUpdateInput: false,
                                singleDatePicker: true,
                                showDropdowns: true,
                                autoApply: true,
                            }}
                        />
                    </div>
                </div>
            </CustomModal.Body>
            <CustomModal.Footer>
                <Flex fullWidth justify="between">
                    <UiButton
                        onClick={onHideModal}
                        btnText={t('Buttons.Cancel.text')}
                        btnColor="secondary"
                    />
                    {!isChangeStatus && (
                        <UiButton
                            onClick={changeStartDate}
                            btnText={t('Gant.ChangeStartDateModal.changeDate.btn.text')}
                        />
                    )}
                    {isChangeStatus && (
                        <UiButton
                            onClick={changeStartDate}
                            btnText={t('Gant.ChangeStartDateModal.isChangeStatus.btn.text')}
                        />
                    )}
                </Flex>
            </CustomModal.Footer>
        </CustomModal>
    );
};
